// extracted by mini-css-extract-plugin
module.exports = {"dropdown-checkbox":"styles_dropdown-checkbox__diW40","placeHolderShimmer":"styles_placeHolderShimmer__3bubb","shimmer":"styles_shimmer__2bgGu"};